const now = new Date();
const jstOffset = 9 * 60 * 60 * 1000;
const jst = new Date(now.getTime() + jstOffset);

const month = jst.getUTCMonth() + 1; // 1-12
const day = jst.getUTCDate();        // 1-31
const dayOfWeek = jst.getUTCDay();   // 0=日〜6=土
const hour = jst.getUTCHours();      // 0-23（JSTの時）
const isAfternoon = hour >= 12;

let text = '';

/* =========================
   年末年始 特別ルール
   12/31〜1/4 → 1/9-1/10
========================= */
const isYearEndHoliday =
  (month === 12 && day === 31) ||
  (month === 1 && day >= 1 && day <= 4);

if (isYearEndHoliday) {
  text = '1月9日-10日';
} else {
  /* =========================
     通常：+1〜+3
     金曜かつ午後：+4〜+6
  ========================= */
  let addStart = 1;
  let addEnd = 3;

  if (dayOfWeek === 5 && isAfternoon) { // 金曜かつ午後
    addStart = 4;
    addEnd = 6;
  }

  // ★JST固定のままブレないようにUTC系で加算
  const getFormattedDate = (baseDate, offset) => {
    const d = new Date(baseDate);
    d.setUTCDate(d.getUTCDate() + offset);
    return {
      month: d.getUTCMonth() + 1,
      day: d.getUTCDate()
    };
  };

  const start = getFormattedDate(jst, addStart);
  const end = getFormattedDate(jst, addEnd);

  if (start.month === end.month) {
    text = `${start.month}月${start.day}日-${end.day}日`;
  } else {
    text = `${start.month}月${start.day}日-${end.month}月${end.day}日`;
  }
}

const el = document.getElementById('delivery-date-range');
if (el) el.textContent = text;
